<template>
  <div class="BottomContent">
    <div class="BottomContent_content">
      <div class="tit">{{$t('DataInfo.Recommend')}}</div>
      <div class="BottomContent_img_box" v-if="otherdatalist.length>0">
        <div
          class="BottomContent_img"
          v-for="(item,index) in otherdatalist.slice(0,4)"
          :key="index"
          @click="toOther(item.dataId)"
        >
          <div class="BottomContent_img_con">
            <img :src="`${GLOBAL.imageUrl}${item.image}`" alt />
          </div>

          <div class="txt">{{item.productName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["otherdatalist"],
  methods: {
    toOther(val) {
      this.$router.push(`/datainfo?dataId=${val}`);
    }
  }
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 1026px) {
  .BottomContent {
    width: 100%;
    height: 365px;
          display: flex;
      flex-direction: column;
      justify-content: center;
    background: #006a9d;
    // position: relative;
    .BottomContent_content {
      width: 1200px;
      margin: auto;
      overflow: hidden;

      .tit {
        color: #fff;
        margin: 20px 0;
        font-size: 32px;
      }
      .BottomContent_img_box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        cursor: pointer;
        .BottomContent_img {
          &:hover img {
            transition: 0.2s;
            transform: scale(1.2);
            opacity: 0.7;
          }
          .BottomContent_img_con {
            width: 267px;
            height: 177px;
            overflow: hidden;
            img {
              transition: 0.2s;
              width: 100%;
              height: 100;
              object-fit: cover;
            }
          }

          .txt {
            margin: 8px 0;
            color: #fff;
            font-size: 16px;
            width: 267px;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .BottomContent {
    width: 100%;
    height: 365px;
    background: #006a9d;
    // position: relative;
    .BottomContent_content {
      width: 1200px;
      margin: auto;
      overflow: hidden;
      .tit {
        color: #fff;
        margin: 20px 0;
        font-size: 32px;
      }
      .BottomContent_img_box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        cursor: pointer;
        .BottomContent_img {
          &:hover img {
            transition: 0.2s;
            transform: scale(1.2);
            opacity: 0.7;
          }
          .BottomContent_img_con {
            width: 267px;
            height: 177px;
            overflow: hidden;
            img {
              transition: 0.2s;
              width: 100%;
              height: 100;
              object-fit: cover;
            }
          }

          .txt {
            margin: 8px 0;
            color: #fff;
            font-size: 16px;
            width: 267px;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
    .BottomContent {
      padding: 0 10px;
    // width: 100%;
    // height: 365px;
    background: #006a9d;
    
    // position: relative;
    .BottomContent_content {
      width: 100%;
      margin: auto;

      overflow: hidden;
      .tit {
        color: #fff;
        margin: 20px 0;
        font-size: 22px;
      }
      .BottomContent_img_box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        cursor: pointer;
        .BottomContent_img {
                margin-bottom: 8px;
          .BottomContent_img_con {
            width: 100%;
            height: 220px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .txt {
            margin: 8px 0;
            color: #fff;
            font-size: 16px;
            width: 267px;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
</style>